module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('bsf-viewbox', [_c('bsf-navbar', {
    attrs: {
      "logo": _vm.bslogo,
      "fixed": "top"
    },
    slot: "navbar"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "left"
    },
    slot: "left"
  }, [_c('sidebar')]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "right"
    },
    slot: "right"
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    attrs: {
      "transition": "back"
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view', {
    attrs: {
      "transition": "back"
    }
  }) : _vm._e()]), _vm._v(" "), _c('routebox', {
    slot: "tools"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-6e4b49f8!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 325
// module chunks = 2